'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defaultResourceReducer = require('../../utils/services/http/resources/reducers/defaultResourceReducer');

var _defaultResourceReducer2 = _interopRequireDefault(_defaultResourceReducer);

var _elementHelper = require('../../../common/elements/elementHelper');

var _elementConstants = require('../../../common/elements/elementConstants');

var _socketConstants = require('../../utils/socket/socketConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Constants
// Reducers
var elementCreateUpdate = function elementCreateUpdate(state, action) {
    return state.set('fetched', true).set('fetching', false);
};

// Utils

exports.default = function (state, action) {
    var updatedState = (0, _defaultResourceReducer2.default)(state, action);

    switch (action.type) {
        case _elementConstants.ELEMENT_CREATE:
            return (0, _elementHelper.isBoard)(action.elementType) ? elementCreateUpdate(updatedState, action) : updatedState;
        case _socketConstants.SOCKET_DISCONNECT:
            return updatedState.set('fetched', false);
        default:
            return updatedState;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/board/boardsResourceReducer.js
// module id = 1955
// module chunks = 0